import { render } from "./OfferAndPrivacyPolicyView.vue?vue&type=template&id=1b9708b2&scoped=true"
import script from "./OfferAndPrivacyPolicyView.vue?vue&type=script&lang=js"
export * from "./OfferAndPrivacyPolicyView.vue?vue&type=script&lang=js"

import "./OfferAndPrivacyPolicyView.vue?vue&type=style&index=0&id=1b9708b2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b9708b2"]])

export default __exports__